import { cwslapi } from "../index";


// 礼包兑换 - 活动管理
export const giftExchangeApi = (data) => { 
  return cwslapi({
    url: "/activity/giftExchange",
    method: "post",
    data,
  });
};


